import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getModuleTemplateContext = basicSelector(state => {
  var _state$moduleTemplate;
  return ((_state$moduleTemplate = state.moduleTemplateContext) === null || _state$moduleTemplate === void 0 ? void 0 : _state$moduleTemplate.templateContext) || {};
});